export default __webpack_public_path__ + "static/media/1246.52d21ca1.png";